// extracted by mini-css-extract-plugin
export default {"sort":"RR-z","sortSelect":"SR-z","disabled":"TR-z"};